import apiClient from "@/api/client";
import { API_ENDPOINTS } from "@/api/endpoints";
import type { ChatThreadDetail, ChatThreadSummary } from "@/types/expressChat";

const unwrap = <T>(payload: unknown): T => {
  if (payload && typeof payload === "object" && "data" in payload) {
    const inner = (payload as { data?: unknown }).data;
    if (inner && typeof inner === "object") return inner as T;
  }
  return payload as T;
};

export async function listChatThreads(): Promise<ChatThreadSummary[]> {
  const res = await apiClient.get(API_ENDPOINTS.CHAT.THREADS);
  const payload = unwrap<unknown>(res.data);
  if (Array.isArray(payload)) return payload as ChatThreadSummary[];
  if (payload && typeof payload === "object" && "threads" in payload) {
    const threads = (payload as { threads?: ChatThreadSummary[] }).threads;
    return Array.isArray(threads) ? threads : [];
  }
  return [];
}

export async function getChatThread(
  threadId: number | string,
): Promise<ChatThreadDetail> {
  const res = await apiClient.get(API_ENDPOINTS.CHAT.THREAD(threadId));
  const payload = unwrap<
    ChatThreadDetail & { thread?: ChatThreadDetail; firebase?: ChatThreadDetail["firebase"] }
  >(res.data);
  const nested =
    payload.thread && typeof payload.thread === "object" ? payload.thread : null;
  const firebase = payload.firebase ?? nested?.firebase;
  return {
    ...(nested ?? {}),
    ...payload,
    firebase,
  } as ChatThreadDetail;
}

export async function sendArtistChatMessageHttp(
  threadId: number | string,
  body: string,
): Promise<void> {
  await apiClient.post(API_ENDPOINTS.CHAT.THREAD_MESSAGES(threadId), { body });
}

export function normalizeBookingId(value?: string | null): string {
  return (value ?? "").replace(/\s+/g, "").toUpperCase();
}
